module.exports = __webpack_public_path__ + "img/1723542086793-e9eb49e1-2bf9-4859-8369-dee79abe6956.jpeg.2bc1527b.webp";